import React from 'react';
import { ZdsFormLabel, ZdsRadio, ZdsRadioGroup } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
const RadioFilter = ({ filter, handleFilterChange }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(ZdsFormLabel, null,
            React.createElement(Translation, { item: filter.label })),
        React.createElement(ZdsRadioGroup, null, filter.options.map((filterOption) => (React.createElement(ZdsRadio, { key: filterOption.label, onZdsChange: handleFilterChange, name: filter.field, value: filterOption.filterValue },
            React.createElement(Translation, { item: filterOption.label })))))));
};
export default RadioFilter;
